export const ApiSettingsLegacyTemplates = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/legacy-templates/${id || 0}`, payload)
    return result.data
  }

  const remove = async (id) => {
    await axios.delete(`/api/settings/legacy-templates/${id}`)
  }

  const find = async (id) => {
    let result
    if (id) {
      result = await axios.get(`/api/settings/legacy-templates/${id}`)
    } else {
      result = await axios.get('/api/settings/legacy-templates/0')
    }
    return result.data
  }

  const load = async (type, page = 1) => {
    let result
    if (type) {
      result = await axios.get(`/api/settings/legacy-templates?type=${type}&page=${page}`)
    } else {
      result = await axios.get(`/api/settings/legacy-templates?page=${page}`)
    }
    return result.data
  }

  return {
    legacyTemplatesFind: find,
    legacyTemplatesLoad: load,
    legacyTemplatesSave: save,
    legacyTemplatesRemove: remove
  }
}
